export default "__VITE_ASSET__7w5YdH_E__"